import { useEffect } from 'react';
import { addBodyClass, removeBodyClass } from '../utils/dom';
/** State management for nested modals. */
class ModalManager {
    constructor() {
        this.modals = [];
        this.add = (modal) => {
            this.modals.push(modal);
        };
        this.remove = (modal) => {
            this.modals = this.modals.filter(m => m !== modal);
        };
        this.isTopModal = (modal) => {
            const topmostModal = this.modals[this.modals.length - 1];
            return topmostModal === modal;
        };
    }
}
export const manager = new ModalManager();
/** Refs of new modals will be automatically added/removed from the state when rendering. */
export function useModalManager(ref, isOpen, disableScrollLock) {
    useEffect(() => {
        if (isOpen) {
            manager.add(ref);
            if (!disableScrollLock)
                addBodyClass('vui-no-scroll');
        }
        return () => {
            manager.remove(ref);
            if (!disableScrollLock)
                removeBodyClass('vui-no-scroll');
        };
    }, [isOpen, ref]);
}
